import { ITranslation } from '../ITranslation';

export class EnglishTranslation implements ITranslation {
  public language = 'en';
  public add = 'Add';
  public dataLoadingFailureMessage = 'Data could not be loaded. Please reload the page.';
  public newElement = 'New element';
  public cancel = 'Cancel';
  public confirmDeletion = 'Do you really want to delete this object?';
  public invalidValue = 'Please enter a valid value.';
  public sorting = 'Sorting';
  public sortingAscending = 'Sorting ascending';
  public sortingDescending = 'Sorting descending';
  public sortingThenAscending = 'Add to sorting ascending';
  public sortingThenDescending = 'Add to sorting descending';
  public columns = 'Columns';
  public moveColumnLeft = 'Move column to the left';
  public moveColumnRight = 'Move column to the right';
  public hideColumn = 'Hide column';
  public showColumn = 'Show column';
  public filter = 'Filter';
  public equals = 'Equals';
  public notEquals = 'Not equals';
  public contains = 'Contains';
  public isEmpty = 'Is empty';
  public isNotEmpty = 'Is not empty';
  public before = 'Before';
  public after = 'After';
  public between = 'Between';
  public yes = 'Yes';
  public no = 'No';
  public ok = 'OK';
  public filterText = 'Filter text';
}
